/** * @Author: tianhongjie * @Date: 2021-07-29 15:15:52 * @Description:
预约问卷调查 */
<template>
  <div class="page-background-new">
    <div class="page-div">
      <div class="page-div-context">
        <div class="page-div-context-title">住院患者陪护人员承诺书</div>
      </div>
      <van-form @submit="submit">
        <div class="question-box">
          <div
            v-for="(item, index) in list"
            :key="index"
            class="question-box-context"
          >
            <div class="question-box-question">
              {{ index + 1 }}. {{ item.title }}
            </div>
            <div class="question-box-select">
              <van-radio-group v-model="item.answer" direction="horizontal">
                <van-radio name="是"
                  >是
                  <template #icon="props">
                    <img
                      class="img-icon"
                      :src="props.checked ? activeIcon : inactiveIcon"
                    />
                  </template>
                </van-radio>
                <van-radio name="否" style="padding-left: 7.19rem"
                  >否
                  <template #icon="props">
                    <img
                      class="img-icon"
                      :src="props.checked ? activeIcon : inactiveIcon"
                    />
                  </template>
                </van-radio>
              </van-radio-group>
            </div>
          </div>
          <div>
            <!--<van-field
            v-model="name"
            label="陪护本人姓名"
            placeholder="本人姓名"
            input-align="right"
            error-message-align="right"
            :rules="[{ required: true, message: '请输入姓名' }]"
          />
          <van-field
            v-model="phone"
            label="联系方式"
            placeholder="请输入手机号"
            input-align="right"
            error-message-align="right"
            :rules="[{ required: true,pattern: /^1(3|4|5|6|7|8|9)\d{9}$/, message: '请填写正确的手机号' }]"
          />-->
            <van-field
              v-model="answer9"
              readonly
              label="陪护与患者关系"
              placeholder="请选择您与患者的关系"
              input-align="right"
              right-icon="arrow-down"
              @click="showPicker = true"
            />
            <van-popup v-model="showPicker" position="bottom">
              <van-picker
                show-toolbar
                :columns="columns"
                @confirm="onConfirm"
                @cancel="showPicker = false"
              />
            </van-popup>
            <van-field
              v-show="showAnswer10"
              v-model="answer10"
              placeholder="请输入您与患者关系"
            />
            <van-field v-show="false" />
          </div>
          <!--<div style="padding: 0 0.67rem">
          <div
            style="padding-top:1rem;padding-bottom:1.07rem;color: #FE5546;font-weight: 500;font-size: 1.2rem"
          >
            温馨提示：
          </div>
          <div
            style="padding-bottom:0.9rem;color: #FE5546;font-weight: 400;font-size: 0.87rem;line-height: 1.38rem"
          >
            对以上填报信息的真实性负责。如因隐瞒或虚假填报引起检疫传染病传播或者有传播严重危险而影响公共安全的后果，本人将承担相应的法律责任。
          </div>
        </div>-->
        </div>
        <ph-button
          title="确认提交"
          style="margin: 1.88rem 1rem; border-radius: 2rem"
        />
      </van-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIcon: require("@/assets/icon_check_radio.png"),
      inactiveIcon: require("@/assets/icon_nocheck_radio.png"),
      list: [
        { title: "本人是否属于新冠肺炎确诊病例、无症状感染者？", answer: "" },
        {
          title:
            "14天内，是否出现发热、干咳、乏力、鼻塞、流涕、咽痛、腹泻等症状？",
          answer: ""
        },
        {
          title: "14天内，是否从中高风险地区回来？",
          answer: "",
          required: true
        },
        {
          title:
            "14天内，是否从境外(含港澳台)回来，或与境外(含港澳台)回来人员接触过？",
          answer: ""
        },
        {
          title:
            "14天内，是否与新冠肺炎确诊病例、疑似病例或已发现无症状感染者有接触史？",
          answer: ""
        },
        {
          title:
            "14天内，有无接触过新冠肺炎病例报告区域的发热或有呼吸道症状的患者    ",
          answer: ""
        },
        { title: "本人“八闽健康码”是否为绿码？", answer: "" },
        { title: "共同居住家庭成员中是否有上述1至6的情况？", answer: "" }
      ],
      answer9: "",
      answer10: "",
      pageInfo: {},
      columns: [
        "护工",
        "丈夫",
        "妻子",
        "爸爸",
        "妈妈",
        "儿子",
        "女儿",
        "女婿",
        "媳妇",
        "爷爷",
        "奶奶",
        "外公",
        "外婆",
        "孙子",
        "孙女",
        "哥哥",
        "姐姐",
        "其他"
      ],
      showPicker: false,
      showAnswer10: false,
      name: "",
      phone: ""
    };
  },
  computed: {},
  created() {
    this.pageInfo = this.$route.query;
  },
  mounted() {
    this.setBaseFontSize();
  },
  beforeDestroy() {
    let htmlDom = document.getElementsByTagName("html")[0];
    htmlDom.style.fontSize = "";
  },
  methods: {
    setBaseFontSize() {
      /*上面设置font-size的代码*/
      let htmlWidth =
        document.documentElement.clientWidth || document.body.clientWidth; // 获取宽度最好有个兼容的方案，避免某些情况下第一种获取不到可以选择第二种
      //获取html
      let htmlDom = document.getElementsByTagName("html")[0];
      htmlDom.style.fontSize = htmlWidth > 640 ? "16px" : htmlWidth / 25 + "px";
    },
    onConfirm(value) {
      this.answer9 = value;
      this.showPicker = false;
      if (value === "其他") {
        this.showAnswer10 = true;
      } else {
        this.showAnswer10 = false;
      }
    },
    submit() {
      if (this.answer9 == "") {
        this.$toast("请选择您与患者的关系");
        return false;
      }
      if (this.answer9 == "其他") {
        if (this.answer10 == "") {
          this.$toast("请填写您与患者的关系");
          return false;
        }
      }
      /**if(this.name==""){
        this.$toast("请填写姓名");
        return false;
      }
      if(!this.$regular.phone(this.phone)){
        this.$toast("请填写正确手机号");
        return false;
      }*/
      const param = {
        answer1: this.list[0].answer,
        answer2: this.list[1].answer,
        answer3: this.list[2].answer,
        answer4: this.list[3].answer,
        answer5: this.list[4].answer,
        answer6: this.list[5].answer,
        answer7: this.list[6].answer,
        answer8: this.list[7].answer,
        answer9: this.answer9,
        answer10: this.answer10,
        functionType: "2",
        name: this.name,
        phone: this.phone
      };
      let t = false;
      this.list.map((item, index) => {
        if (index != 6) {
          if (!item.answer || item.answer == "是") {
            t = true;
          }
        } else {
          if (!item.answer || item.answer == "否") {
            t = true;
          }
        }
      });
      if (t) {
        this.$toast("流行病学调查表中有不符合陪护要求的选项答案，禁止提交");
        return;
      }
      this.$http.post(this.$api.ESCORTPEOPLE_ADDSURVEY, param).then(() => {
        this.$toast("提交成功");
        this.$router.push({
          path: "/escortpeople/add",
          query: {
            ...this.pageInfo
          }
        });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.page-div {
  margin: 1rem;
  &-context {
    width: 100%;
    height: 3.13rem;
    text-align: center;
    background: #09f;
    border-radius: 0.66rem 0.66rem 0 0;
    &-title {
      color: #fff;
      font-weight: 600;
      font-size: 1.13rem;
      line-height: 3rem;
    }
  }
}
.question-box {
  padding: 1rem;
  background: white;
  border-radius: 0 0 0.66rem 0.66rem;
  &-context {
    margin-bottom: 1rem;
    padding: 1rem;
    background: #fff;
    border: 1px solid #efefef;
    border-radius: 0.33rem;
    box-shadow: 0 0.2rem 0.53rem 0 rgba(228, 228, 228, 0.4);
  }
  &-question {
    padding-bottom: 1rem;
    color: #333;
    font-weight: 400;
    font-size: 0.94rem;
  }
  &-select {
    font-size: 0.88rem;
  }
}
.img-icon {
  height: 0.94rem;
}
</style>
<style lang="less">
.question-box {
  .van-field__label {
    width: auto;
    color: #333;
    font-weight: 400;
    font-size: 1rem;
    line-height: 1.6rem;
  }
}
</style>
